import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';
import type { RequestOptions } from '@/libs/api/types';

/** Path (relative to `buildUrl`) for dismissing a player's invitation. */
export const playerInvitationEndpoint = (playerId: string, invitationId: string) =>
  `/guardians/me/players/${playerId}/invitations/${invitationId}`;

/**
 * Dismisses an invitation (owner only): revokes it if still pending, deletes it once
 * already dead (revoked/declined/expired). DELETE returns 204 (no content).
 * DELETE `/api/v1/guardians/me/players/{playerId}/invitations/{invitationId}` — the
 * path's `invitationId` is the invitation token, i.e. `PlayerGuardian.invitationCode`.
 */
export async function revokePlayerInvitation(
  playerId: string,
  invitationId: string,
  options?: RequestOptions,
): Promise<void> {
  await usKidsGolfService.delete<void>(
    buildUrl(playerInvitationEndpoint(playerId, invitationId)),
    options,
  );
}
